import { render, staticRenderFns } from "./HistoryDetailComplaint.vue?vue&type=template&id=0e137c90"
import script from "./HistoryDetailComplaint.vue?vue&type=script&lang=js"
export * from "./HistoryDetailComplaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports